import p from './store-manage.vue';

export default p;
